import React from 'react';
import logo from 'assets/img/biz-capital-logo-2019.png';
import poligonoLogo from 'assets/img/poligono.png';
import estimuloLogo from 'assets/img/estimulo2020.png';
import { ESTIMULO_BRAND, POLIGONO_BRAND, getProductBrand } from 'constants/brand-constants';
import './bizon-screen-wrapper.styles.scss';

const getBrandLogo = () => {
    const brand = getProductBrand();

    switch (brand.branchName) {
        case POLIGONO_BRAND.branchName:
            return {
                src: poligonoLogo,
                alt: 'poligono-logo',
                className: 'poligono-logo bizcap-logo',
            };
        case ESTIMULO_BRAND.branchName:
            return {
                src: estimuloLogo,
                alt: 'estimulo-logo',
                className: 'estimulo-logo bizcap-logo',
            };
        default:
            return {
                src: logo,
                alt: 'bizcap-logo',
                className: 'bizcap-logo',
            };
    }
};

const BizonScreenWrapper: React.FC = ({ children }): JSX.Element => {
    const brandLogo = getBrandLogo();

    return (
        <div className="bizon-screen-wrapper">
            <div className="bizon-screen-wrapper__header">
                <div className="bizon-screen-wrapper__logo grid-container">
                    <img
                        src={brandLogo.src}
                        alt={brandLogo.alt}
                        className={brandLogo.className}
                    />
                </div>
            </div>
            <div className="bizon-screen-wrapper__content">
                {children}
            </div>
        </div>
    );
};

export default BizonScreenWrapper;
